import { scrollAnimataion } from './scroll-animataion/scroll-animataion.js';
import { markerSet } from './marker-set/marker-set.js';
import { fadeJudge } from './to-top-btn-fade/to-top-btn-fade.js';

// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimataion({
  className: "commercialList",
  triggerPoint: 100,
});


// ===========================================
// 大見出しのインタラクション
// ===========================================
$(function () {
  let num = 1;
  $('.beyondListHeadYear__txt').find('span').each(function(){
    const span = $(this),
          maxNum = Number( span.attr('data-max') );

    function numSet( span ) {
      span.html( num );
      num =  Math.ceil( num + num / 5 ) ;

      if( num <= maxNum ) {
        setTimeout(function () {
          numSet( span );
        }, 25);
      } else {
        span.html( maxNum );
      }
    }

    setTimeout(function () {
      numSet( span );
    }, 990);
  });

  function markerSet( area ) {
    const ttl = area.find('.beyondListHead__ttl'),
          subTtl = area.find('.beyondListHeadSubTtl'),
          year = area.find('.beyondListHeadYear'),
          txt = area.find('.beyondListHead__txt'),
          outline = area.find('.beyondOutline');
    let scroll = $(window).scrollTop();

    if( area.offset().top < scroll + $(window).height() - 200 ) {
      ttl.addClass('markerOn');

      setTimeout(function () {
        ttl.addClass('markerOff');
        ttl.addClass('gTxtOn');

        setTimeout(function () {
          ttl.addClass('gTxtOff');
        }, 200);

        subTtl.addClass('markerOn');

        setTimeout(function () {
          subTtl.addClass('markerOff');
          subTtl.addClass('gTxtOn');

          setTimeout(function () {
            txt.addClass('markerOn');

            setTimeout(function () {
              txt.addClass('markerOff');
              txt.addClass('gTxtOn');

              setTimeout(function () {
                txt.addClass('gTxtOff');

                setTimeout(function () {
                  outline.addClass('markerOn');

                  setTimeout(function () {
                    outline.addClass('markerOff');
                    outline.addClass('gTxtOn');

                    setTimeout(function () {
                      outline.addClass('gTxtOff');
                    }, 200);

                  }, 300);
                }, 100);

              }, 200);

            }, 300);
          }, 100);

          area.addClass('active');

          setTimeout(function () {
            year.addClass('on');
          }, 600);
        }, 200);

      }, 300);
    }
  }

  $('.beyondListArea').each(function(){
    const area = $(this);
    markerSet( area );
  });
});


// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimataion({
  className: "c-beyondList__item--listPage",
  triggerPoint: 100,
});


// ===========================================
// ビヨンドリストのレイアウト
// ===========================================
$(function () {
  $('.c-beyondList').each(function(){
    const box = $(this).find('.c-beyondList__box');
    let widthBefore = $(window).width();

    function heightSet() {
      if( $(window).width() > 640 ) {
        box.tile(4);
      } else {
        box.tile(2);
      }
    }
    heightSet();

    $(window).on('resize', function(){
      if( $(window).width() !== widthBefore ) {
        box.css({ height: 'auto' });
        setTimeout(function () {
          heightSet();
        }, 250);
      }
    });
  });
});


// ===========================================
// 中見出しのインタラクション
// ===========================================
$(function () {
  markerSet( $('.commercialArea') );

  $(window).on('scroll', function(){
    markerSet( $('.commercialArea') );
  });
});


// ===========================================
// コマーシャルリンクボタンのインタラクション
// ===========================================
$(function () {
  const area = $('.toCmArea');
  let scroll = $(window).scrollTop() + $(window).height(),
      fadePoint = $('.commercialArea').offset().top;

  function scrollSet() {
    if( scroll >= fadePoint ) {
      area.addClass('off');
    } else {
      area.removeClass('off');
    }
  }

  scrollSet();

  $(window).on('scroll', function(){
    scroll = $(window).scrollTop() + $(window).height();
    fadePoint = $('.commercialArea').offset().top;

    scrollSet();
  });
});


// ===========================================
// コーマシャルエリアのカードのディレイ
// ===========================================
$(function () {
  $('.commercialList').each(function(){
    const list = $(this);
    let delay = 0;

    function setDelay( item , n ) {
      delay = .1 + (.05 * n);

      item.css({ transitionDelay: delay + 's' });
    }

    list.find('.commercialList__item').each(function( n ){
      const item = $(this);

      setDelay( item , n );

      $(window).on('resize', function(){
        setDelay( item , n );
      });
    });
  });
});


// ===========================================
// コーマシャルエリアのモーダルのインタラクション
// ===========================================
$(function () {
  const modal = $('.cmModal'),
        shadow = modal.find('.cmModalShadow'),
        close = modal.find('.cmModalClose');

  $('.commercialList__item').on('click', function(){
    const printFrame = $(this).attr('data-print');

    modal.find('.cmModal__box').prepend( cmModalHtmls[ printFrame ] );
    modal.addClass('on');
    $("html").css({ overflow: "hidden" });
  });

  close.on('click', function(){
    modal.removeClass('on');
    $("html").css({ overflow: "auto" });
    modal.find('iframe').remove();
  });

  shadow.on('click', function(){
    close.click();
  });
});


// ===========================================
// モーダルのスライドショー
// ===========================================
$(function () {
  // 50枚のスライドショーを実行すると処理に負担がかかりすぎるため、
  // ajaxを利用してスライドショーを実行する。
  // 50枚のそれぞれのスライドショーのソースコードを個別に配列に格納する（※html側に記述）。
  // 3枚の空のスライドショーを実行する。
  // その空のスライドショーの操作状況に応じて、
  // 配列から該当するスライドのソースコードを取り出して配置する。

  // スクロールバーを発生させるか判定する処理の関数
  function scrollSet( slideItem ) {
    slideItem.each(function(){
      const scrollArea = slideItem.find('.scroll-area');

      let itemHeight = slideItem.height(),
          tmbHeight = slideItem.find('.modalSlide__tmb').height(),
          ttlHeight = slideItem.find('.modalSlide__ttl').outerHeight(),
          navHeight = slideItem.find('.modalSlideNavDummy').outerHeight(),
          scrollInnerHeight = scrollArea.find('.scroll-content').height(),
          adjustment,
          txtHeight;

      if( $(window).width() > 640 ) {
        adjustment = 56;
      } else {
        adjustment = 20;
      }

      txtHeight = itemHeight - tmbHeight - ttlHeight - navHeight - adjustment;

      scrollArea.height( txtHeight );

      if( scrollInnerHeight > txtHeight ) {
        slideItem.addClass('scroll');
      } else {
        slideItem.removeClass('scroll');
      }
    });

    // スクロール時に、シャドーを発生させるか判定する処理
    slideItem.find('.scroll-area').each(function(){
      const scrollArea = $(this);

      shadowJudge( slideItem, scrollArea );

      scrollArea.on('scroll', function(){
        shadowJudge( slideItem, scrollArea );
      });
    });
  }

  // シャドーを表示させるか判定する関数
  function shadowJudge( slideItem, scrollArea ) {
    if( scrollArea.scrollTop() >= scrollArea.find('.scroll-content').outerHeight() - scrollArea.height() - 10 ) {
      slideItem.addClass('offShadow');
    } else {
      slideItem.removeClass('offShadow');
    }
  }

  // 戻る・進むボタンのインタラクションの関数
  function prevNextInteraction( slide, nav ) {
    // 戻るボタンのインタラクション
    slide.find('.modalSlideNav__btn--prev').on('click', function(){
      nav.find('.slick-prev').click();
    });

    // 進むボタンのインタラクション
    slide.find('.modalSlideNav__btn--next').on('click', function(){
      nav.find('.slick-next').click();
    });
  }

  // モバイルの戻る・進むボタンの番号を最適化する処理の関数
  function prevNextNumSet( dummyPrevMobile, dummyNextMobile, printSlide ) {
    // モバイルの戻るボタンの番号を最適化
    let prevNum = Number( printSlide ) - 1;
    if( prevNum <= 0 ) {
      prevNum = 50;
    }
    dummyPrevMobile.find('.modalSlideNavBtnIconMobile').html('#' + prevNum);

    // モバイルの進むボタンの番号を最適化
    let nextNum = Number( printSlide ) + 1;
    if( nextNum >= 51 ) {
      nextNum = 1;
    }
    dummyNextMobile.find('.modalSlideNavBtnIconMobile').html('#' + nextNum);
  }

  // スライドの中身を最適化して表示する処理の関数
  function optimalSlidePrint(
    slide,
    nav,
    slideItem,
    printSlide,
    dummyPrevMobile,
    dummyNextMobile
  ) {
    slideItem.html( slideModalHtmls[ printSlide ] );

    // スクロールバーを発生させるか判定する処理
    scrollSet( slideItem );
    $(window).on('resize', function(){
      scrollSet( slideItem );
    });

    // 戻る・進むボタンのインタラクション
    prevNextInteraction( slide, nav );

    // モバイルの戻る・進むボタンの番号を最適化する処理
    prevNextNumSet( dummyPrevMobile, dummyNextMobile, printSlide );

    slideItem.find('.scroll-content a').on('click', function(){
      $('.modalClose').click();
    });
  }


  $('.modalSlide').each(function(){
    const slide = $(this),
          nav = slide.parent().next(),
          dots = $('.modalSlideDots');

    const dummyPrev = slide.find('.modalSlideNav__btn--prev'),
          dummyNext = slide.find('.modalSlideNav__btn--next'),
          dummyPrevMobile = slide.parent().parent().next().find('.modalSlideNavDummyMobile__btn--prev'),
          dummyNextMobile = slide.parent().parent().next().find('.modalSlideNavDummyMobile__btn--next');

    const modal = $('.modalArea'),
          modalClose = modal.find('.modalClose'),
          modalShadow = modal.find('.modalShadow');

    let beforeSlide,
        afterSlide,
        printSlide;

    let slideItem;

    // スライドを実行
    slide.slick({
      autoplay: false,
      appendArrows: nav,
      dots: true,
      appendDots: dots,
      slidesToShow: 1,
      speed: 150,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      pauseOnFocus: false,
      swipeToSlide: true,
    });


    // -----------------------------------------
    // モバイルの戻るボタンのインタラクション
    // -----------------------------------------
    dummyPrevMobile.on('click', function(){
      nav.find('.slick-prev').click();
    });


    // -----------------------------------------
    // モバイルの進むボタンのインタラクション
    // -----------------------------------------
    dummyNextMobile.on('click', function(){
      nav.find('.slick-next').click();
    });


    // -----------------------------------------
    // 各カードをクリックしたときのインタラクション
    // -----------------------------------------
    $('.c-beyondList__item button').on('click', function(){
      // 1枚目のスライドが表示されるようにする処理
      dots.find('.slick-dots li:nth-child(1) button').click();

      slideItem = slide.find('.slick-active .modalSlide__item');
      printSlide = $(this).attr('data-print');

      // スライドの中身を最適化して表示する処理
      optimalSlidePrint(
        slide,
        nav,
        slideItem,
        printSlide,
        dummyPrevMobile,
        dummyNextMobile
      );

      // モーダルを出現させる処理
      setTimeout(function () {
        modal.addClass('open');
        $("html").css({ overflow: "hidden" });
      }, 100);

      // 次回スワイプ（スライド）した際に比較するため、現在のスライド番号を変数に格納
      beforeSlide = 1;
    });


    // -----------------------------------------
    // スワイプ（スライド）した際のインタラクション
    // -----------------------------------------
    slide.on('afterChange', function(slick, currentSlide) {
      slideItem = slide.find('.slick-active .modalSlide__item');
      afterSlide = currentSlide['currentSlide'] + 1;

      // スワイプの前後のスライドが何枚目か比較し、
      // '進んだのか' or '戻ったのか' を判定し、
      // それに応じて最適なスライドの内容を取得
      if(
        ( beforeSlide === 1 && afterSlide === 2 ) ||
        ( beforeSlide === 2 && afterSlide === 3 ) ||
        ( beforeSlide === 3 && afterSlide === 1 )
      ) {
        printSlide++;
        if( printSlide === 51 ) {
          printSlide = 1;
        }
      } else if(
        ( beforeSlide === 1 && afterSlide === 3 ) ||
        ( beforeSlide === 2 && afterSlide === 1 ) ||
        ( beforeSlide === 3 && afterSlide === 2 )
      ) {
        printSlide--;
        if( printSlide === 0 ) {
          printSlide = 50;
        }
      }

      // スライドの中身を最適化して表示する処理
      optimalSlidePrint(
        slide,
        nav,
        slideItem,
        printSlide,
        dummyPrevMobile,
        dummyNextMobile
      );

      // 次回スワイプ（スライド）した際に比較するため、現在のスライド番号を変数に格納
      beforeSlide = afterSlide;
    });


    // -----------------------------------------
    // モーダルを閉じるインタラクション
    // -----------------------------------------
    modalClose.on('click', function(){
      modal.removeClass('open');
      $("html").css({ overflow: "auto" });
    });
    modalShadow.on('click', function(){
      modalClose.click();
    });
  });
});


// ===========================================
// ページ訪問時にモーダルを立ち上げる場合の処理
// ===========================================
$(function () {
  const url = new URL(window.location.href),
        params = url.searchParams;

  if( params ) {
    $('.c-beyondList__item button[data-print="' + Number( params.get('modal') ) + '"]').click();
  }
});


// ===========================================
// ページ上部へ戻るボタンのインタラクション
// ===========================================
$(function () {
  fadeJudge();
});